import { render, staticRenderFns } from "./OpenInNewTabDialog.vue?vue&type=template&id=80164438&scoped=true&"
import script from "./OpenInNewTabDialog.vue?vue&type=script&lang=js&"
export * from "./OpenInNewTabDialog.vue?vue&type=script&lang=js&"
import style0 from "./OpenInNewTabDialog.vue?vue&type=style&index=0&id=80164438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80164438",
  null
  
)

export default component.exports